module.exports = "https://web-assets.ifttt.com/packs/media/partners/book-db1f21c9.svg";